import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { ZendeskAPI } from 'react-zendesk';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from './styles';
import FuelTab from './FuelTab';
import AlarmTab from './AlarmTab';
import CodesTab from './CodesTab';
import PF2MTabs from '~/components/PF2MTabs';
import Main from '../Main';
import { setAlertDialog } from '~/store/manager/actions';
import PF2MAlertDialog from '~/components/PF2MAlertDialog';

const Fuel = ({
  classes,
  setAlertDialog: setDialog,
  isCodesEquipmentLinkMapsDirty,
  isFuelRemainingAlertValuesDirty,
  alertDialog,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:RefuellingPerEquipment') },
    { key: 1, label: translate('common:RemainingLitersAlarm') },
    { key: 2, label: translate('common:ConnectCodes') },
  ];

  const handleChange = (event, value) => {
    let blockChange = false;
    switch (value) {
      default:
      case 0:
        blockChange = (isCodesEquipmentLinkMapsDirty || isFuelRemainingAlertValuesDirty);
        break;
      case 1:
        blockChange = (isCodesEquipmentLinkMapsDirty);
        break;
      case 2:
        blockChange = isFuelRemainingAlertValuesDirty;
        break;
    }

    if (blockChange) {
      event.preventDefault();
      setDialog();
    } else {
      setSelectedTab(value);
    }
  };


  useEffect(() => {
    const timer = setTimeout(() => {
      ZendeskAPI('webWidget', 'hide');
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Main>
        <div className={classes.container}>
          <PF2MTabs
            value={selectedTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
          >
            {tabs}
          </PF2MTabs>
          {selectedTab === 0 ? (<FuelTab />) : null}
          {selectedTab === 1 ? (<AlarmTab />) : null}
          {selectedTab === 2 ? (<CodesTab />) : null}
        </div>
        <PF2MAlertDialog
          hasCancel={false}
          confirmText={translate('common:Understood')}
          description={translate('validation:YouHaveUnsavedData')}
          open={alertDialog}
          onConfirm={() => setDialog()}
        />
      </Main>
    </>
  );
};

Fuel.propTypes = {
  classes: PropTypes.object.isRequired,
  setAlertDialog: PropTypes.func,
  isCodesEquipmentLinkMapsDirty: PropTypes.bool,
  isFuelRemainingAlertValuesDirty: PropTypes.bool,
  alertDialog: PropTypes.bool,
};

Fuel.defaultProps = {
  setAlertDialog: null,
  isCodesEquipmentLinkMapsDirty: false,
  isFuelRemainingAlertValuesDirty: false,
  alertDialog: false,
};

const mapStateToProps = state => ({
  isCodesEquipmentLinkMapsDirty: state.fuel.isCodesEquipmentLinkMapsDirty,
  isFuelRemainingAlertValuesDirty: state.fuel.isFuelRemainingAlertValuesDirty,
  alertDialog: state.manager.alertDialog,
});

const mapDispatchToProps = {
  setAlertDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(Fuel));
